import styled from '@emotion/styled';
import {has} from 'lodash';

const BaseButton = styled.button<{ size?: 'big' | 'small' }>`
    transition: all 200ms ease;
    
    cursor: pointer;
    
    height: ${({ size }) => size === 'big' ? '56px' : '40px'};
    
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    
    border: 1px solid;
    border-radius: ${props => !has(props.theme, 'buttonBorderRadius') ? '0' : props.theme.buttonBorderRadius}px;

    font-family: ${(props) => props.theme.fontFamily};
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    
    &:disabled {
        cursor: auto;
    }
`

BaseButton.defaultProps = {
  type: 'button',
}

export default BaseButton;
